export default __webpack_public_path__ + "static/media/white_check.465e4602.svg";